import React from 'react';
import { styled } from '@mui/material/styles';

import {
    Tooltip,
    Toolbar,
    Typography,
    IconButton,
    Switch,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
} from '@mui/material';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import usePhoneCheck from '../../../hooks/usePhoneCheck';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
}));

const Spacer = styled('div')({
    flex: '1 1 100%',
});

const Actions = styled('div')(({ theme }) => ({
    color: theme.palette.text.secondary,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > *:not(:last-child)': {
        marginRight: theme.spacing(1),
    },
}));

const Title = styled(Typography)({
    flex: '0 0 auto',
});

const ActionsItem = ({ Icon, onClick, title, color, newEqualizer }) => {
    if (typeof newEqualizer === 'boolean') {
        return (
            <Tooltip placement="top" title={title}>
                <Switch onClick={onClick} checked={newEqualizer} color="primary" />
            </Tooltip>
        );
    }

    return (
        <Tooltip placement="top" title={title}>
            <IconButton onClick={onClick} color={color}>
                <Icon />
            </IconButton>
        </Tooltip>
    );
};

const EnhancedTableHeadView = ({ title, actions }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const mobile = usePhoneCheck();

    const handleClick = event => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    if (!actions.length && !title) return null;

    if (mobile) {
        return (
            <StyledToolbar>
                <Typography variant="body1">{title}</Typography>
                <Spacer />
                <Actions>
                    {actions
                        .filter(el => el.outOfMenu)
                        .map(({ Icon, onClick, title, color, newEqualizer }, index) => (
                            <ActionsItem
                                key={index}
                                Icon={Icon}
                                onClick={onClick}
                                title={title}
                                color={color}
                                newEqualizer={newEqualizer}
                            />
                        ))}

                    <Tooltip placement="top" title="Actions">
                        <IconButton onClick={handleClick}>
                            <MoreVertIcon />
                        </IconButton>
                    </Tooltip>

                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                        {actions
                            .filter(el => !el.outOfMenu)
                            .map(({ Icon, onClick, title, newEqualizer }, index) => {
                                const handleMenuItemClick = () => {
                                    onClick();
                                    handleClose();
                                };

                                return (
                                    <MenuItem key={index} onClick={handleMenuItemClick} sx={{ p: 0 }}>
                                        <ListItemIcon>
                                            {typeof newEqualizer === 'boolean' ? (
                                                <Switch checked={newEqualizer} color="primary" />
                                            ) : (
                                                <Icon />
                                            )}
                                        </ListItemIcon>
                                        <ListItemText>
                                            <Typography variant="body2" color="text.secondary">
                                                {title}
                                            </Typography>
                                        </ListItemText>
                                    </MenuItem>
                                );
                            })}
                    </Menu>
                </Actions>
            </StyledToolbar>
        );
    }

    return (
        <StyledToolbar>
            <Title variant="body1">{title}</Title>
            <Spacer />
            <Actions>
                {actions.map(({ Icon, onClick, title, color, newEqualizer }, index) => (
                    <ActionsItem
                        key={index}
                        Icon={Icon}
                        onClick={onClick}
                        title={title}
                        color={color}
                        newEqualizer={newEqualizer}
                    />
                ))}
            </Actions>
        </StyledToolbar>
    );
};

export default EnhancedTableHeadView;
